import graphql__18ba7d9e8bc9f86840f8 from "./__generated__/ContributionsDatavizSearchRouteQuery.graphql.js";import { graphql } from "react-relay";
import { useParams, useOutletContext } from "react-router";
import AppQueryRenderer from "../AppQueryRenderer";

import ContributionsDatavizSearch from "../ParticipativeModule/Visualizations/ContributionsDataviz/ContributionsDatavizSearch";
import { ResourcesListProvider } from "../ResourcesList/resourcesList";
import ResourcesListUrlSearchSync from "../ResourcesList/ResourcesListUrlSearchSync";

const ContributionsDatavizSearchRoute = props => {
  const { participativeModuleSlug } = useParams();
  const { contributionsPerPage: contributionsCount } = useOutletContext();

  return (
    <AppQueryRenderer
      key={participativeModuleSlug}
      query={ContributionsDatavizSearchRouteQuery}
      variables={{ participativeModuleSlug, contributionsCount }}
      additionalProps={props}
    >
      {props => (
        <ResourcesListProvider>
          <ResourcesListUrlSearchSync />
          <ContributionsDatavizSearch {...props} />
        </ResourcesListProvider>
      )}
    </AppQueryRenderer>
  );
};

const ContributionsDatavizSearchRouteQuery = graphql__18ba7d9e8bc9f86840f8;

export default ContributionsDatavizSearchRoute;
